module.exports = __webpack_public_path__ + "img/9.afe4ec4c.jpg";